import Button from "@/Components/Button/Button";
import { useSetLiveModal } from "@/shared/atoms/useLiveModal";
import useCommon from "@/shared/hooks/useCommon";
import useElectronHook from "@/shared/hooks/useElectronHook";
import useRoleHooks from "@/shared/hooks/useRoleHooks";
import { modalNameEnum } from ".";

const LivePrinterButton = () => {
  const t = useCommon();
  const { isElectron } = useElectronHook();
  const { isAppsmenEmployee } = useRoleHooks();
  const setModalName = useSetLiveModal();
  return isElectron || isAppsmenEmployee ? (
    <div onClick={() => setModalName(modalNameEnum.PRINTER_SETTINGS_MODAL)} className="mr-8 font-semibold">
      <Button size="small">{t("orders_live.printerSettings")}</Button>
    </div>
  ) : null;
};

export default LivePrinterButton;
